/* @flow */

export default {
  input: {
    display: 'none',
  },
};
